<template>
  <sidebar-default :title="title">
    <b-card-group columns>
      <b-card v-for="(image, index) in images" v-bind:key="index">
        <a :href="image.downloadUrl" target="_blank">
          <b-card-img v-if="image.src" :src="image.src" :alt="image.title" overlay></b-card-img>
        </a>
      </b-card>
    </b-card-group>
  </sidebar-default>
</template>

<script>
  // Components
  import SidebarDefault from '@/components/layout/templates/sidebar/SidebarDefault';

  export default {
    name: 'SidebarImages',

    props: {
      title: {
        default: 'Images',
        type: String,
      },
      images: Array,
    },

    components: {SidebarDefault}
  }
</script>

<style scoped lang="scss">
  .card-body {
    padding: 5px;
  }

  .card-columns {
    -moz-column-count: 2;
    column-count: 2;
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }

  .card-columns .card {
    display: inline-block;
    width: 100%;
  }

  @media (min-width: 576px) {
    .card-columns {
      -moz-column-count: 3;
      column-count: 3;
      -moz-column-gap: 1.25rem;
      column-gap: 1.25rem;
      orphans: 1;
      widows: 1;
    }
  }
</style>
